// Local replacement for `@eventbrite/eds-layout` `Layout` (no Valkyrie package
// exists). Same public API + same DOM/class output as the eb-ui original so the
// ported page matches the live markup. Emits GLOBAL `eds-layout*` classes (the
// app's `src/styles/cc/*.scss` already keys off `.eds-layout--has-horizontal-gutters
// > .eds-layout__body`, e.g. preview.scss) — the CSS lives in cc.scss.
import React from 'react';

// (The `eds-layout*` global rules are loaded from `_app` via
// `src/styles/cc.scss` — Turbopack forbids global (non-module) CSS imports from
// a component file. See `src/styles/cc.scss` → `../ported/lib/eds/Layout.scss`.)

export type MaxWidth = 'large';
export type PeakSize = 'small' | 'medium' | 'large';

export interface LayoutProps {
    children?: React.ReactNode;
    header?: React.ReactNode;
    maxWidth?: MaxWidth;
    peakSize?: PeakSize;
    hasHorizontalGutters?: boolean;
}

export const Layout = ({
    children,
    header,
    maxWidth,
    peakSize,
    hasHorizontalGutters = false,
}: LayoutProps) => {
    const className = [
        'eds-layout',
        peakSize ? `eds-layout--has-${peakSize}-peak` : '',
        maxWidth ? `eds-layout--has-${maxWidth}-max-width` : '',
        hasHorizontalGutters ? 'eds-layout--has-horizontal-gutters' : '',
    ]
        .filter(Boolean)
        .join(' ');

    return (
        <section className={className} data-spec="eds-layout">
            {header ? (
                <header
                    className="eds-layout__header"
                    data-spec="eds-layout__header"
                >
                    {header}
                </header>
            ) : null}
            <div className="eds-layout__body" data-spec="eds-layout__body">
                {children}
            </div>
        </section>
    );
};

export default Layout;
